import { logShutteringEvent } from '../firebase'
export const useGoogleAnalytics = () => logShutteringEvent
